import {
  PROVIDER_PLAN_CHANGE_VALUES,
} from '@/store/constants/mutationTypes';
import initialState from './providerPlanInitialState';

const mutations = {
  [PROVIDER_PLAN_CHANGE_VALUES]: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      state[field] = value;
    });
  },
};

export default mutations;
